import React from 'react'
import Layout from '../../components/Layout'
import H1 from '../../components/H1'

export default function Page() {
  return (
    <Layout>
      <H1 title="Jobs" />
      {/* <p>
        No jobs listed at this time.
        The following positions are currently open to qualified seekers.
      </p> */}
        <ul>
        {/* <li>
          <a target="_blank" rel="noopener" href="https://www.usajobs.gov/job/863892500">
          Air University - Chief Graduate Professional Education and Program Enhancement
          </a>
          <p>
            The Chief of Graduate Professional Education coordinates and aligns Air University's curricula across all graduate programs. This role advises schools and programs on curriculum development and supports academic program reviews. Key duties include advising on instructional design, curriculum delivery, instructional methodologies, briefing leaders on findings, drafting policy/guidance, and collaborating with multiple stakeholders to sustain high-quality, policy-compliant, accredited curriculum.
          </p>
        </li> */}
        <li>
          <a target="_blank" rel="noopener" href="https://www.usajobs.gov/job/868434200">
          Air University - Chief of Institutional Analytics and Research Data
          </a>
          <p>
            The Chief of Institutional Analytics and Research Data serves as the expert on data analysis at Air University (AU). The incumbent conducts analyses on educational processes, students, faculty, and staff and interprets data to support educational effectiveness, continuous improvement, and accreditation. Reports directly to the Deputy Provost and collaborates across the university as an academic administrator.
          </p>
        </li>
        <li>
          <a target="_blank" rel="noopener" href="https://jobs.auburn.edu/auburn-careers-home/jobs/8661?lang=en-us">
          Auburn University - Analyst, Institutional Studies
          </a>
          <p>
            The Office of Institutional Research is looking for an Analyst to provide demographic, analytical and other information about the University, its programs and its student population and assists in developing and maintaining data systems to support their analysis.
          </p>
        </li>
        </ul>
    </Layout>
  )
}
